// extracted by mini-css-extract-plugin
module.exports = {"currencyType":"_93444fe79c--currencyType--n8z0U"};